export default function verifyProfile(user, permission) {
  let hasPermission = true;
  user.roles.forEach(r => {
    if(r.permissions.find(p => p.slug === permission)) {
      hasPermission = true;
    }
  });

  return hasPermission;
}